import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AdminPanel from './Admin';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Ruteo simple sin react-router: /admin → AdminPanel, resto → App
const isAdmin = window.location.pathname.startsWith('/admin');

root.render(
  <React.StrictMode>
    {isAdmin ? <AdminPanel /> : <App />}
  </React.StrictMode>
);
